import "./templates/main.js";
import "./components/modal.js";

import "../sass/app.scss";
import "../sass/legal.scss";
